module.exports = __webpack_public_path__ + "img/games-17.1e0f2249.webp";